import BaseRestService from './baseRestService';

const _serviceDependencies = ['$http', '$q', 'Util'];

/**
 * @ngdoc service
 * @name rest.services.PaymentUrlsRestService
 *
 * @description
 * This class contains methods used to retrieve information about payment urls
 * using http requests.
 */
export default class PaymentUrlsRestService extends BaseRestService {

    /**
     * @param  {any} $http
     * @param  {any} $q
     * @param  {any} Util
     */
    constructor($http, $q, Util) {

        super($http, $q, Util);

    }

    /**
    * @ngdoc function
    * @name rest.services.PaymentUrlsRestService#getByAppId
    * @methodOf rest.services.PaymentUrlsRestService
    * @function
    *
    * @description
    * Retrieves payment urls.
    *
    * @returns {Promise} The promise of the call.
    */
    getByAppId(appId, subsource) {

        return super.getAllAsync(`payment-urls/?filter[source]=cw&filter[app]=${appId}${subsource ? `&filter[subsource]=${subsource}` : ''}`);

    }

    /**
    * @ngdoc function
    * @name rest.services.PaymentUrlsRestService#getByAppIdAndLicenseId
    * @methodOf rest.services.PaymentUrlsRestService
    * @function
    *
    * @description
    * Retrieves payment urls.
    *
    * @returns {Promise} The promise of the call.
    */
    getByAppIdAndLicenseId(appId, subsource, licenseId) {

        return super.getAllAsync(`payment-urls/?filter[source]=cw&filter[app]=${appId}${subsource ? `&filter[subsource]=${subsource}` : ''}&filter[license]=${licenseId}`);

    }

    /**
    * @ngdoc function
    * @name rest.services.PaymentUrlsRestService#getPromotionByAppId
    * @methodOf rest.services.PaymentUrlsRestService
    * @function
    *
    * @description
    * Retrieves payment urls.
    *
    * @returns {Promise} The promise of the call.
    */
    getPromotionByAppId(appId, subsource) {

        return super.getAllAsync(`payment-urls/?filter[source]=cw&filter[app]=${appId}&upsaleTo=${appId}${subsource ? `&filter[subsource]=${subsource}` : ''}`);

    }

    /**
    * @ngdoc function
    * @name rest.services.PaymentUrlsRestService#getByAppIdAndRuntime
    * @methodOf rest.services.PaymentUrlsRestService
    * @function
    *
    * @description
    * Retrieves payment urls.
    *
    * @returns {Promise} The promise of the call.
    */
    getByAppIdAndRuntime(appId, runtime, subsource) {

        return super.getAllAsync(`payment-urls/?filter[source]=cw&filter[app]=${appId}&filter[runtime]=${runtime}${subsource ? `&filter[subsource]=${subsource}` : ''}`);

    }

    /**
    * @ngdoc function
    * @name rest.services.PaymentUrlsRestService#ggetByAppIdRuntimeAndUpsell
    * @methodOf rest.services.PaymentUrlsRestService
    * @function
    *
    * @description
    * Retrieves payment urls.
    *
    * @returns {Promise} The promise of the call.
    */
    getByAppIdRuntimeAndUpsell(appId, runtime, subsource, licenseId) {

        return super.getAllAsync(`payment-urls/?filter[source]=cw&filter[app]=${appId}&filter[runtime]=${runtime}${subsource ? `&filter[subsource]=${subsource}` : ''}&filter[license]=${licenseId}&upsellTo=${appId}`);

    }

    /**
    * @ngdoc function
    * @name rest.services.PaymentUrlsRestService#getPromotionByAppIdAndUpsell
    * @methodOf rest.services.PaymentUrlsRestService
    * @function
    *
    * @description
    * Retrieves payment urls.
    *
    * @returns {Promise} The promise of the call.
    */
    getPromotionByAppIdAndUpsell(appId, subsource, licenseId) {

        return super.getAllAsync(`payment-urls/?filter[source]=cw&filter[app]=${appId}&upsaleTo=${appId}${subsource ? `&filter[subsource]=${subsource}` : ''}&filter[license]=${licenseId}&upsellTo=${appId}`);

    }

}

_serviceDependencies.push(PaymentUrlsRestService);

angular.module('rest.services')
    .service('PaymentUrlsRestService', _serviceDependencies);



// WEBPACK FOOTER //
// ./scripts/restServices/paymentUrlsRestService.js